import { render, staticRenderFns } from "./RewardPicture.vue?vue&type=template&id=059ea086&"
import script from "./RewardPicture.vue?vue&type=script&lang=js&"
export * from "./RewardPicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports